import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useMsal } from "@azure/msal-react";

import { Holidays } from '../../../../api-client';
import { IHookCallback } from '../../../../common/models';
import { HolidaysApiClient } from '../../../../providers/api-provider';
import { NotificationHelper } from '../../../../utils/notification';

export const useHolidays = () => {
    const {
        instance
    } = useMsal();

    const {
        t: translate
    } = useTranslation();

    const [holidays, setHolidays] = useState<Holidays>();
    const [holidaysLoading, setHolidaysLoading] = useState<boolean>(false);

    const retrieveHolidays = async () => {
        setHolidaysLoading(true);

        const clientApi = await HolidaysApiClient(instance);

        clientApi.getHolidays()
            .then((response) => {
                if(response.data) {
                 setHolidays(response.data);
                }
            })
            .catch((reason) => {
                setHolidays({});

                NotificationHelper.createNotification({
                    type: 'error',
                    title: translate('settingPage.holidaysDrawer.notification.retrieve.title'),
                    message: translate('settingPage.holidaysDrawer.notification.retrieve.message')
                });
            })
            .finally(() => {
                setHolidaysLoading(false);
            });
    }

    // CRUD Operations

    interface ICreateHolidays extends IHookCallback {
        dates: string[];
    }

    const [createHolidaysLoading, setCreateHolidaysLoading] = useState<boolean>(false);

    const handleCreateHolidays = async (params: ICreateHolidays) => {
        setCreateHolidaysLoading(true);

        const clientApi = await HolidaysApiClient(instance);

        clientApi.insertHolidays({dates: params.dates})
            .then((response) => {

                params.onSuccess && params.onSuccess();

                NotificationHelper.createNotification({
                    type: 'success',
                    title: translate('settingPage.holidaysDrawer.notification.createSuccess.title'),
                    message: translate('settingPage.holidaysDrawer.notification.createSuccess.message')
                });
            })
            .catch((reason) => {
                params.onError && params.onError();

                NotificationHelper.createNotification({
                    type: 'error',
                    title: translate('settingPage.holidaysDrawer.notification.createError.title'),
                    message: translate('settingPage.holidaysDrawer.notification.createError.message')
                });
            })
            .finally(() => {
                setCreateHolidaysLoading(false);

                params.onAlways && params.onAlways();
            });
    }

    interface IUpdateHolidays extends IHookCallback {
        id: string;
        holidays: Holidays;
    }

    const [updateHolidaysLoading, setUpdateHolidaysLoading] = useState<boolean>(false);

    const handleUpdateHolidays = async (params: IUpdateHolidays) => {
        setUpdateHolidaysLoading(true);

        const clientApi = await HolidaysApiClient(instance);

        clientApi.updateHolidays(params.id, params.holidays)
            .then((response) => {
                params.onSuccess && params.onSuccess();

                NotificationHelper.createNotification({
                    type: 'success',
                    title: translate('settingPage.holidaysDrawer.notification.updateSuccess.title'),
                    message: translate('settingPage.holidaysDrawer.notification.updateSuccess.message')
                });
            })
            .catch((reason) => {
                params.onError && params.onError();

                NotificationHelper.createNotification({
                    type: 'error',
                    title: translate('settingPage.holidaysDrawer.notification.updateError.title'),
                    message: translate('settingPage.holidaysDrawer.notification.updateError.message')
                });
            })
            .finally(() => {
                setUpdateHolidaysLoading(false);

                params.onAlways && params.onAlways();
            });
    }

    return {
        holidays,
        holidaysLoading,
        retrieveHolidays,
        createHolidaysLoading,
        handleCreateHolidays,
        updateHolidaysLoading,
        handleUpdateHolidays
    }
}